import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { OccasionData } from 'client/bundles/types';
import Date from 'client/components/date';
import DocsList, { DocsView } from 'client/components/docs-list';

import './index.css';

const b = cn('meetings-list');

interface Props {
    occasions: OccasionData[];
    docsView?: DocsView;
}

class MeetingsList extends Component<Props> {
    renderItem = (item: OccasionData, index: number) => {
        const { dateStart, location, docs } = item;

        return (
            <article key={index} className={b('item')}>
                <div className={b('item-left')}>
                    <div className={b('year')}>
                        <Date dateStart={dateStart} format="YYYY" color="black" />
                    </div>

                    <div className={b('details')}>
                        <span className={b('date')}>
                            <Date dateStart={dateStart} format="MMMM DD" />
                        </span>
                        { location && <span className={b('location')}>, {location}</span> }
                    </div>
                </div>

                <div className={b('item-right')}>
                    <DocsList view={this.props.docsView} docs={docs} />
                </div>
            </article>
        );
    }

    render() {
        return (
            <div className={b()}>
                { this.props.occasions.map(this.renderItem) }
            </div>
        );
    }
}

export default MeetingsList;
